import { jsx as n } from "../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import T from "classnames";
import { useMemo as N } from "../../../../external/preact/hooks/dist/hooks.module.js";
import H from "../../../../core/Context/useCoreContext.js";
import M from "../../../internal/Accordion/Accordion.js";
import S from "../../../internal/Card/Card.js";
import { TypographyVariant as e } from "../../../internal/Typography/types.js";
import m from "../../../internal/Typography/Typography.js";
import k from "../../../internal/DataOverviewDetails/DataOverviewDetailsSkeleton.js";
import z from "../../../../hooks/useTimezoneAwareDateFormatting.js";
/* empty css                */
import { PD_BASE_CLASS as G, PD_TITLE_CLASS as J, PD_TITLE_CONTAINER_CLASS as K, PD_SECTION_CLASS as l, PD_TITLE_BA_CLASS as q, PD_CONTENT_CLASS as Q, PD_CARD_CLASS as _, PD_SECTION_AMOUNT_CLASS as f, PD_SECTION_GROSS_AMOUNT_CLASS as R, PD_CARD_TITLE_CLASS as F, PD_SECTION_NET_AMOUNT_CLASS as W, PD_UNPAID_AMOUNT as X } from "./constants.js";
import { Tag as Z } from "../../../internal/Tag/Tag.js";
import { TagVariant as b } from "../../../internal/Tag/types.js";
import { DATE_FORMAT_PAYOUT_DETAILS as j } from "../../../../constants/dateFormats.js";
import y from "../../../internal/StructuredList/StructuredList.js";
import { Fragment as w } from "../../../../external/preact/dist/preact.module.js";
import { EMPTY_OBJECT as V } from "../../../../utils/value/constants.js";
const Si = ({
  balanceAccountId: $,
  balanceAccountDescription: p,
  payout: s,
  isFetching: ii
}) => {
  var B;
  const { payout: t } = s ?? V, { dateFormat: P } = z("UTC"), { i18n: r } = H(), o = N(() => {
    var a, h;
    const c = (h = (a = s == null ? void 0 : s.amountBreakdowns) == null ? void 0 : a.adjustmentBreakdown) == null ? void 0 : h.reduce(
      (d, i) => {
        var L, E, I, D, Y, U, u;
        const v = (L = i == null ? void 0 : i.amount) != null && L.value && ((E = i == null ? void 0 : i.amount) != null && E.currency) ? r.amount((I = i == null ? void 0 : i.amount) == null ? void 0 : I.value, (D = i == null ? void 0 : i.amount) == null ? void 0 : D.currency, { hideCurrency: !0 }) : (((Y = i == null ? void 0 : i.amount) == null ? void 0 : Y.value) ?? "").toString(), A = `${i == null ? void 0 : i.category}`, g = r.get(A), C = i != null && i.category && g !== A ? g : i == null ? void 0 : i.category;
        return i != null && i.category && v && C && d[(U = i == null ? void 0 : i.amount) != null && U.value && ((u = i == null ? void 0 : i.amount) == null ? void 0 : u.value) < 0 ? "subtractions" : "additions"].push({ key: C, value: v }), d;
      },
      { subtractions: [], additions: [] }
    );
    return c == null || c.subtractions.sort((d, i) => d.key.localeCompare(i.key)), c == null || c.additions.sort((d, i) => d.key.localeCompare(i.key)), c;
  }, [r, s]), O = N(() => {
    var a, h;
    const c = (h = (a = s == null ? void 0 : s.amountBreakdowns) == null ? void 0 : a.fundsCapturedBreakdown) == null ? void 0 : h.reduce((d, i) => {
      var v, A, g, C;
      return ((v = i == null ? void 0 : i.amount) == null ? void 0 : v.value) === 0 || (A = i == null ? void 0 : i.amount) != null && A.value && i.category && d.push({
        key: i.category,
        value: r.amount((g = i == null ? void 0 : i.amount) == null ? void 0 : g.value, (C = i == null ? void 0 : i.amount) == null ? void 0 : C.currency, { hideCurrency: !0 })
      }), d;
    }, []);
    return c == null || c.sort((d, i) => d.key === "capture" ? -1 : i.key === "capture" ? 1 : d.key.localeCompare(i.key)), c;
  }, [s, r]), x = N(
    () => t != null && t.createdAt ? P(new Date(t == null ? void 0 : t.createdAt), j) : "",
    [t, P]
  );
  return /* @__PURE__ */ n(w, { children: t ? /* @__PURE__ */ n("div", { className: G, children: [
    /* @__PURE__ */ n("div", { className: J, children: [
      /* @__PURE__ */ n("div", { className: K, children: [
        /* @__PURE__ */ n(m, { variant: e.SUBTITLE, stronger: !0, children: r.get("netPayout") }),
        t.isSumOfSameDayPayouts && /* @__PURE__ */ n(Z, { variant: b.BLUE, label: r.get("sumOfSameDayPayouts") })
      ] }),
      /* @__PURE__ */ n(m, { variant: e.TITLE, large: !0, children: `${r.amount(t.payoutAmount.value, t.payoutAmount.currency, {
        hideCurrency: !0
      })} ${t.payoutAmount.currency}` }),
      /* @__PURE__ */ n(m, { variant: e.BODY, children: x }),
      /* @__PURE__ */ n("div", { className: l, children: [
        p && /* @__PURE__ */ n(m, { variant: e.CAPTION, stronger: !0, wide: !0, children: `${p}` }),
        /* @__PURE__ */ n(m, { variant: e.CAPTION, className: q, children: `${$}` })
      ] })
    ] }),
    /* @__PURE__ */ n("div", { className: Q, children: [
      /* @__PURE__ */ n("div", { className: l, children: (t == null ? void 0 : t.fundsCapturedAmount) && (O && Object.keys(O).length > 0 ? /* @__PURE__ */ n(
        M,
        {
          header: /* @__PURE__ */ n(m, { variant: e.BODY, children: r.get("fundsCaptured") }),
          headerInformation: /* @__PURE__ */ n(m, { variant: e.BODY, children: r.amount(t.fundsCapturedAmount.value, t.fundsCapturedAmount.currency) }),
          children: /* @__PURE__ */ n("div", { className: l, children: /* @__PURE__ */ n("div", { className: _, children: /* @__PURE__ */ n(S, { noPadding: !0, children: /* @__PURE__ */ n(y, { items: O }) }) }) })
        }
      ) : /* @__PURE__ */ n("div", { className: T(f, R), children: [
        /* @__PURE__ */ n(m, { variant: e.BODY, children: r.get("fundsCaptured") }),
        /* @__PURE__ */ n(m, { variant: e.BODY, children: r.amount(t.fundsCapturedAmount.value, t.fundsCapturedAmount.currency) })
      ] })) }),
      /* @__PURE__ */ n("div", { className: l, children: o != null && o.subtractions && Object.keys(o == null ? void 0 : o.subtractions).length > 0 || o != null && o.additions && Object.keys(o == null ? void 0 : o.additions).length > 0 ? /* @__PURE__ */ n(
        M,
        {
          header: /* @__PURE__ */ n(m, { variant: e.BODY, children: r.get("adjustments") }),
          headerInformation: /* @__PURE__ */ n(m, { variant: e.BODY, children: r.amount(t.adjustmentAmount.value, t.adjustmentAmount.currency) }),
          children: [
            (o == null ? void 0 : o.additions) && Object.keys(o == null ? void 0 : o.additions).length > 0 && /* @__PURE__ */ n("div", { className: _, children: /* @__PURE__ */ n(
              S,
              {
                noPadding: !0,
                renderHeader: /* @__PURE__ */ n(m, { className: F, variant: e.CAPTION, stronger: !0, children: r.get("additions") }),
                children: /* @__PURE__ */ n(y, { items: o == null ? void 0 : o.additions })
              }
            ) }),
            (o == null ? void 0 : o.subtractions) && Object.keys(o == null ? void 0 : o.subtractions).length > 0 && /* @__PURE__ */ n("div", { className: _, children: /* @__PURE__ */ n(
              S,
              {
                noPadding: !0,
                renderHeader: /* @__PURE__ */ n(m, { className: F, variant: e.CAPTION, stronger: !0, children: r.get("subtractions") }),
                children: /* @__PURE__ */ n(y, { items: o == null ? void 0 : o.subtractions })
              }
            ) })
          ]
        }
      ) : /* @__PURE__ */ n("div", { className: T(f, R), children: [
        /* @__PURE__ */ n(m, { variant: e.BODY, children: r.get("adjustments") }),
        /* @__PURE__ */ n(m, { variant: e.BODY, children: r.amount(t.adjustmentAmount.value, t.adjustmentAmount.currency) })
      ] }) }),
      /* @__PURE__ */ n("div", { className: T(l), children: /* @__PURE__ */ n("div", { className: T(f, W), children: [
        /* @__PURE__ */ n(m, { variant: e.BODY, stronger: !0, children: r.get("netPayout") }),
        /* @__PURE__ */ n(m, { variant: e.BODY, stronger: !0, children: r.amount(t.payoutAmount.value, t.payoutAmount.currency) })
      ] }) })
    ] }),
    ((B = s == null ? void 0 : s.payout) == null ? void 0 : B.unpaidAmount) && /* @__PURE__ */ n("div", { className: X, children: [
      /* @__PURE__ */ n(m, { variant: e.BODY, children: r.get("remainingAmount") }),
      /* @__PURE__ */ n(m, { variant: e.BODY, children: r.amount(s.payout.unpaidAmount.value, s.payout.unpaidAmount.currency) })
    ] })
  ] }) : /* @__PURE__ */ n(k, { skeletonRowNumber: 6 }) });
};
export {
  Si as PayoutData
};
